import { forwardRef } from 'react';

import { Box, type BoxProps, Typography } from '@mui/material';

const InfoTooltipInner = forwardRef((props: BoxProps, ref) => {
  return (
    <Box
      ref={ref}
      {...props}
      sx={[
        {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 32,
          height: 32,
          py: 0.5,
          px: 1.5,
          borderRadius: '100%',
          background:
            'linear-gradient(13deg, rgba(247, 248, 253, 0.05) 20.33%, rgba(255, 255, 255, 0.05) 48.75%)',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Typography
        component="span"
        variant="body1"
        sx={{
          color: 'text.secondary',
          textTransform: 'lowercase',
        }}
      >
        i
      </Typography>
    </Box>
  );
});

export default InfoTooltipInner;
